import React from "react";
import { hmcAssets } from "../../lib/data";
import VimeoEmbed from "./VimeoVideoEmbed";

// css
import "./HmcAssets.css";

import aboutVideo from "../../assets/videos/DIR0006 - About DIR Video - FINAL.mp4";

const HmcAssets = () => {
  return (
    <div section="hmc-assets" className="hmc-assets-wrapper">
      <div className="main-padding">
        <div class="main-margin grid lg:grid-cols-2 items-center gap-8">
          <div>
            <p className="t-white mb-12">
              StratCap Digital Infrastructure REIT, Inc. (“DIR”)(Closed to new
              investors), targets mission-critical digital infrastructure
              assets that fuel many of today’s most transformative technology
              megatrends.
            </p>
            <div class="grid grid-cols-2 gap-3">
              {/* <div class="asset-grid"> */}
              {hmcAssets.map((a, i) => {
                return (
                  <div className="asset-grid-item">
                    <div className="w-10">
                      <img src={a.image} alt={a.alt} />
                    </div>
                    <div className="pl-3">
                      <span className="text-white">{a.title}</span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div>
            {/* <video src={aboutVideo} controls className="w-full"></video> */}
            <VimeoEmbed
              videoId="1045420088"
              title="About StratCap Digital Infrastructure REIT, Inc."
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HmcAssets;
